module.exports = __webpack_public_path__ + "img/customer2.1d8595ce.png";